<template>
  <form name="images" method="post" action="">
  <input type="file" class="btn create" name="images" multiple v-on:change="setFiles" ref="file">
  <input type="button" class="btn" v-on:click="uploadFile" value="アップロード">
  </form>
</template>

<script>
// import axios from "axios";

import axios from "axios";
import store from "@/store";

export default {
  name: 'ImageUpload',
  props: [""],
  data:function(){
    return {
      images: {},
    }
  },
  methods: {
    setFiles:function (){
      this.images = this.$refs.file.files
    },
    uploadFile(){
      const formData = new FormData();
      const textbook_id = store.getters.textbookId
      formData.append("textbook_id", textbook_id)
      for (var i = 0; i< this.images.length; i++){
        formData.append("img" + i, this.images[i])
      }
      const headers = { 'content-type': 'multipart/form-data' }
      axios.post('pages', formData, { headers })
          .then(res => {
            console.log(res)
          })
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.create {
  display: flex;
  justify-content: flex-end;
}

</style>
